

export const environment = {
    production: false,


//login
LoginUser: "Account/Login",
Register: "Account/Register",
CompleteProfile: "Account/CompleteProfile",
GetProfile: "Account/GetInfo",
UpdateProfile: "Account/UpdateInfo",
ResetPassword: "Account/ResetPassword",

//Dashboard
GetHomeStatus: "Dashboard/Status",
GetHomeData: "Home/GetHomeData",

//Section
GetAllSection: "Section/GetSections",
AddSection: "Section/AddSection",
EditSection: "Section/EditSection",
DeleteSection: "Section/DeleteSection",


//EvaluationRate
GetAllEvaluationRate: "EvaluationRate/GetEvaluationRates",
AddEvaluationRate: "EvaluationRate/AddEvaluationRate",
DeleteEvaluationRate: "EvaluationRate/DeleteEvaluationRate",

//Content
GetAllContents: "Content/GetContents",
AddContent: "Content/AddContent",
EditContent: "Content/EditContent",
DeleteContent: "Content/DeleteContent",

// userprofile 

GetEmpData: "UserProfile/GetEmployeeData",
GetSectionRow: "UserProfile/GetSectionView",

GetEmpDecisions: "UserProfile/GetEmpDecisions",
GetEmpCourse: "UserProfile/GetEmpCourse",
GetEmpLeaveRequest: "UserProfile/GetEmpLeaveRequest",
GetEmployeeAttendance: "UserProfile/GetEmployeeAttendance",
GetMajalsUserProfileData: "UserProfile/GetMajalsUserProfileData",
Decrypt:"UserProfile/Decrypt",
GetAcadmicTable: "UserProfile/GetAcadmicTable"


}                            